export enum StepCard {
  estimate,
  moreInfo,
  location,
  estimateConfirmation,
  registration,
  gffp,
  fraud,
  summary,
  confirmation,
}

export enum Step {
  estimate,
  moreInfo,
  location,
  estimateConfirmation,
  basicInfo,
  address,
  gffp,
  fraud,
  summary,
  confirmation,
}
